import { Injectable } from '@angular/core';
import {
  INotification,
  NotificationType
} from '../interfaces/notification.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private notificationSource = new BehaviorSubject<INotification | null>(null);
  notificationBroadcasted$ = this.notificationSource.asObservable();

  constructor() {
    this.notificationBroadcasted$.subscribe((notification: INotification) => {
      if (notification !== null) {
        switch (notification.Type) {
          case NotificationType.information:
            console.log(notification.Message, notification.Payload);
            break;
          case NotificationType.error:
            console.error(notification.Message, notification.Payload);
            break;
        }
      }
    });
  }

  broadcastNotification(notification: INotification) {
    this.notificationSource.next(notification);
  }
}
